
import { Component, Prop } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import AppConsts from "@/lib/appConst";

class EmailBindingDto {
  emailAddress: String;
  newEmailAddress: String;
  emailValidationCode: String;
}

@Component
export default class EmailBinding extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  saveLoading: boolean = false;
  emailBindingDto: EmailBindingDto = new EmailBindingDto();
  countDown: number = 0;
  emailBindingRules = {
    newEmailAddress: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("NewPassword")),
        trigger: "blur",
      },
      { type: "email", message: this.L("InvalidEmail"), trigger: "blur" },
    ],
    emailValidationCode: [
      { required: true, message: this.L("FieldIsRequired"), trigger: "blur" },
    ],
  };

  get user() {
    if (this.$store.state.session.user) {
      return this.$store.state.session.user;
    } else {
      return {};
    }
  }
  created() {
    this.emailBindingDto.emailAddress = this.user.emailAddress;
  }
  sendEmailValidationCode() {
    let rules = this.emailBindingRules;
    delete this.emailBindingRules.emailValidationCode;

    (this.$refs.emailBindingForm as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      this.emailBindingDto.emailValidationCode = "";
      this.countDown = 6;
      this.$store
        .dispatch({
          type: "userProfile/sendEmailValidationCode",
          data: this.emailBindingDto,
        })
        .then((data) => {
          this.$Message.success({
            content: "发送成功（若有归入垃圾邮件也请留意）！",
            duration: 6,
          });
          if (this.countDown > 0) {
            let i1 = setInterval(() => {
              if (this.countDown === 0) {
                clearInterval(i1);
              } else {
                this.countDown--;
              }
            }, 1000);
          }
          this.emailBindingRules = rules;
        });
    });
  }
  save() {
    (this.$refs.emailBindingForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (!this.emailBindingDto.emailValidationCode) {
          this.$Message.warning(
            this.L(
              "ThisFieldIsRequired",
              AppConsts.localization.defaultLocalizationSourceName,
              this.L("EmailValidationCode")
            )
          );
          return;
        }
        await this.$store
          .dispatch({
            type: "userProfile/changeEmailAddress",
            data: this.emailBindingDto,
          })
          .then(() => {
            this.$Modal.success({
              title: this.L("Tips"),
              content: this.L("EmailBindingSuccess"),
              onOk: () => {
                this.$router.push("home");
              },
            });
          });
      }
    });
  }
}
